import { AbstractConnector } from '@web3-react/abstract-connector'
import METAMASK_ICON_URL from '../assets/images/metamask.png'
import { ChainId } from '@xterswap/sdk-core'
import {
  Icon,
  IconChainBscScalable,
  IconChainXterioScalable,
  IconBinanceScalable,
  IconBybitScalable,
  IconOkxScalable,
} from 'xterio-icons'
import { walletConnectors, WalletSDKType } from '../connectors/customConnectors'

export interface WalletInfo {
  connector?: AbstractConnector
  name: string
  iconURL: string
  description: string
  href: string | null
  color: string
  primary?: true
  mobile?: true
  mobileOnly?: true
  icon?: Icon
}

export const SUPPORTED_WALLETS: { [key: string]: WalletInfo } = {
  METAMASK: {
    connector: walletConnectors[WalletSDKType.METAMASK],
    name: 'MetaMask',
    iconURL: METAMASK_ICON_URL,
    description: 'Easy-to-use browser extension.',
    href: null,
    color: '#E8831D',
  },
  [WalletSDKType.OKX]: {
    connector: walletConnectors[WalletSDKType.OKX],
    name: WalletSDKType.OKX,
    iconURL: '',
    icon: IconOkxScalable,
    description: 'OKX Wallet',
    href: null,
    color: '#E8831D',
  },
  [WalletSDKType.BINANCE]: {
    connector: walletConnectors[WalletSDKType.BINANCE],
    name: WalletSDKType.BINANCE,
    iconURL: '',
    icon: IconBinanceScalable,
    description: 'Binance Wallet',
    href: null,
    color: '#E8831D',
  },
  [WalletSDKType.BYBIT]: {
    connector: walletConnectors[WalletSDKType.BYBIT],
    name: WalletSDKType.BYBIT,
    iconURL: '',
    icon: IconBybitScalable,
    description: 'Bybit Wallet',
    href: null,
    color: '#E8831D',
  },
  // WALLET_CONNECT: {
  //   connector: walletconnect,
  //   name: 'WalletConnect',
  //   iconURL: WALLETCONNECT_ICON_URL,
  //   description: 'Connect to Trust Wallet, Rainbow Wallet and more...',
  //   href: null,
  //   color: '#4196FC',
  //   mobile: true,
  // },
}

interface AddEthereumChainParameter {
  chainId: string // A 0x-prefixed hexadecimal string
  chainName: string
  nativeCurrency: {
    name: string
    symbol: string // 2-6 characters long
    decimals: 18
  }
  rpcUrls: string[]
  blockExplorerUrls?: string[]
  iconUrls?: string[] // Currently ignored.
}

export enum NETWORK_NAME {
  BSC = 'BSC',
  XTERIO = 'XTERIO',
  XTERIO_ETH = 'XTERIO_ETH',
  XTERIO_TESTNET = 'XTERIO_TESTNET',
}

export const ADD_CHAIN_CONFIG: Partial<Record<NETWORK_NAME, AddEthereumChainParameter>> = {
  BSC: {
    chainId: '0x38',
    chainName: 'BNB Smart Chain Mainnet',
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB', // 2-6 characters long
      decimals: 18,
    },
    rpcUrls: [
      'https://bsc-dataseed.bnbchain.org',
      'https://bsc-dataseed1.bnbchain.org',
      'https://bsc-dataseed2.bnbchain.org',
      'https://bsc-dataseed3.bnbchain.org',
      'https://bsc-dataseed4.bnbchain.org',
    ],
    blockExplorerUrls: ['https://bscscan.com'],
  },
  XTERIO: {
    chainId: '0x1B6E6',
    chainName: 'Xterio Chain (BNB)',
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB', // 2-6 characters long
      decimals: 18,
    },
    rpcUrls: ['https://bnb-rpc.xter.io'],
    blockExplorerUrls: ['https://bnb.xterscan.io'],
  },
  XTERIO_ETH: {
    chainId: '0x293B30',
    chainName: 'Xterio Chain (ETH)',
    nativeCurrency: {
      name: 'ETH',
      symbol: 'ETH', // 2-6 characters long
      decimals: 18,
    },
    rpcUrls: ['https://eth-rpc.xter.io'],
    blockExplorerUrls: ['https://eth.xterscan.io'],
  },
  XTERIO_TESTNET: {
    chainId: '0x18FC4A',
    chainName: 'Xterio Testnet',
    nativeCurrency: {
      name: 'Test BNB',
      symbol: 'tBNB', // 2-6 characters long
      decimals: 18,
    },
    rpcUrls: ['https://testnet-rpc.xter.io'],
    blockExplorerUrls: ['https://testnet.xterscan.io'],
  },
}

export const NETWORK_LABELS: {
  [chainId in ChainId]?: { name: string; network: NETWORK_NAME; icon: Icon; canSwitch?: boolean }
} = {
  [ChainId.XTERIO_TESTNET]: {
    network: NETWORK_NAME.XTERIO_TESTNET,
    name: 'Xterio Testnet',
    icon: IconChainXterioScalable,
    // canSwitch: true,
  },
  [ChainId.XTERIO]: {
    network: NETWORK_NAME.XTERIO,
    name: 'Xterio Chain (BNB)',
    icon: IconChainXterioScalable,
    canSwitch: false,
  },
  [ChainId.BNB]: {
    network: NETWORK_NAME.BSC,
    name: 'BNB Chain',
    icon: IconChainBscScalable,
    canSwitch: true,
  },
}
